module.exports = __webpack_public_path__ + "img/border-center-v.bd57adf2.svg";